import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Fieldset,
  Legend,
  Label
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import CustomSelect from "../../GlobalComponents/CustomSelect";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import Select from "react-select";
import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar";

import { Link, useHistory, Redirect } from "react-router-dom";

import apiResponse from "../../../../services/apiResponse";

import CreateBloc from "./Blocs/CreateBloc";


import { accessRole } from "../../../../helpers/access_role";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import moment from "moment";

export const createMonthOptions = () => {
  const months = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];

  return months.map((month, index) => ({
    label: month,
    value: index + 1,
  }));
};

export const createYearOptions = (startYear = 2000) => {
  const currentYear = new Date().getFullYear();

  return Array.from(
    { length: currentYear - startYear + 1 },
    (_, index) => {
      const year = startYear + index;
      return {
        label: year,
        value: year,
      };
    }
  );
};



class IndexView extends Component {
  createBloc = new CreateBloc();

  // Retrieve Data Pegawai by Admin / Pegawai
  userdata = JSON.parse(localStorage.getItem("userdata"));
  employeeSeleted = JSON.parse(localStorage.getItem("employeeSelected"));
  peg_uuid = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_uuid
      : ""
    : this.employeeSeleted != null
    ? this.employeeSeleted.employee_uuid
    : "";

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      positionItems: [],
      PositionSelected: "",
      echelonItems: [],
      echelonSelected: "",
      positionStatusItems: [],
      PositionStatusSelected: "",
      workUnitFormItems: [],
      workUnitFormSelected: "",
      workUnitToItems: [],
      workUnitToSelected: "",
      signantoryItems: [],
      signatorySelected: "",
      data_employee: [],
      emp_jabatan: "",
      totcredit: 0,
      totcredit2: 0,
      creditType:1,
      start_month  : moment().format("M"),
      end_month  : moment().format("M"),
      year: moment().format("YYYY"),
      yearOptions : createYearOptions(),
      monthOptions : createMonthOptions(),
      typeOptions : [
        { value: 1, label: "Periode(Tahunan)" },
        {
          value: 2,
          label: "Periodik",
        },
      ]
    };
  }

  submitData = async () => {
    const formData = generateFormData(this.state.dataForm, ["file_skp", "file_pak"]); // 'document' disini adalah nama field FileInput. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto']
    await this.createBloc.fetchCreate(formData);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        employee_uuid: this.peg_uuid,
        ...values,
      },
      confirm: true,
    });
  };

  onChangePosition = (PositionSelected) => {
    this.setState({
      PositionSelected: PositionSelected.value,
    });
  };

  onChangeEchelon = (echelonSelected) => {
    this.setState({
      echelonSelected: echelonSelected.value,
    });
  };

  onChangePositionStatus = (PositionStatusSelected) => {
    this.setState({
      PositionStatusSelected: PositionStatusSelected.value,
    });
  };

  onChangeWorkUnitForm = (workUnitFormSelected) => {
    this.setState({
      workUnitFormSelected: workUnitFormSelected.value,
    });
  };

  onChangeWorkUnitTo = (workUnitToSelected) => {
    this.setState({
      workUnitToSelected: workUnitToSelected.value,
    });
  };

  onChangeSignatory = (signatorySelected) => {
    this.setState({
      signatorySelected: signatorySelected.value,
    });
  };

  // handleTotalCreditChange = (e) => {
  //   const value = e.target.value;
  //   this.setState({ totcredit: parseFloat(value) });
  // };
  handleTotalCreditChange = (e) => {
    let value = e.target.value;
  
    // Replace koma dengan titik
    value = value.replace(",", ".");
  
    // Optional: remove extra chars
    value = value.replace(/[^0-9.]/g, "");
  
    // Simpan sebagai number
    const numericValue = parseFloat(value);
  
    this.setState({ creditNumberValue: numericValue });
  };
  

  handleTotalCreditChange2 = (e) => {
    const value = e.target.value;
    this.setState({ totcredit2: parseFloat(value) });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.createBloc.createChannel.subscribe((result) => {
        switch (result.status) {
            case apiResponse.COMPLETED:
                this.setState({
                    loading: false,
                    success: true,
                });
                break
            case apiResponse.ERROR:
                this.setState({
                    gagal_txt: "Gagal!",
                    loading: false,
                    failed: true,
                });
                break
            default:
                break
        }
    })


  }

  componentWillUnmount() {
    this.createBloc.createChannel.unsubscribe()
  }


  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
               <PegawaiSideBar active="riwayat_angkakredit" />
              <Card className="pegawai-rightbar">
                <CardBody>
                  <CardTitle>Tambah Riwayat Angka Kredit</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <AvField
                        type="hidden"
                        name="type_submit"
                        value={2}
                        className="form-control"
                        />
                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Tipe Angka Kredit <span className="text-danger">*</span>
                      </Label>
                      <Col md="5">
                        <CustomSelect
                          name="credit_number_type"
                          errorMessage="Pilih Tipe Angka Kredit"
                          options={this.state.typeOptions}
                          placeholder="Pilih Tipe Angka Kredit"
                          defaultValue={1}
                          onChange={(v) => {
                            this.setState({ creditType: v.value });
                          }}
                          isAvForm={false}
                        />
                        < AvField
                          type="hidden"
                          name="credit_number_type"
                          value={this.state.creditType}
                          className="form-control"/>
                      </Col>
                    </Row>

                    {this.state.creditType == 1 && (
                        <>
                          <Row className="mb-3">
                            <label htmlFor="name" className="col-md-3 col-form-label">
                              Tahun {" "}
                              <span className="text-danger">*</span>
                            </label>
                            <Col md="5">
                              <CustomSelect
                                  name="credit_number_year"
                                  errorMessage="Pilih Tahun"
                                  options={this.state.yearOptions}
                                  placeholder="Pilih Tahun"
                                  defaultValue={this.state.year}
                                  onChange={(v) => {
                                    this.setState({ year: v.value });
                                  }}
                                  isAvForm={false}
                                />

                                <AvField
                                  type="hidden"
                                  name="credit_number_year"
                                  value={this.state.year}
                                  className="form-control"
                                  />
                            </Col>
                          </Row>
                        </>
                      ) }
                          

                    {this.state.creditType == 2 && (
                      <>
                        <Row className="mb-3">
                          <label htmlFor="name" className="col-md-3 col-form-label">
                            Tahun {" "}
                            <span className="text-danger">*</span>
                          </label>
                          <Col md="5">
                          <CustomSelect
                              name="credit_number_year"
                              errorMessage="Pilih Tahun"
                              options={this.state.yearOptions}
                              placeholder="Pilih Tahun"
                              defaultValue={this.state.year}
                              onChange={(v) => {
                                this.setState({ year: v.value });
                              }}
                              isAvForm={false}
                            />

                          <AvField
                            type="hidden"
                            name="credit_number_year"
                            value={this.state.year}
                            className="form-control"/>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                        <label htmlFor="name" className="col-md-3 col-form-label">
                          Bulan Awal{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <Col md="5">
                          <CustomSelect
                            name="credit_number_start_month"
                            errorMessage="Pilih Bulan Awal"
                            options={this.state.monthOptions}
                            placeholder="Pilih Bulan Awal"
                            defaultValue={this.state.start_month}
                            onChange={(v) => {
                              this.setState({ start_month: v.value });
                            }}
                            isAvForm={false}
                          />
                            <AvField
                            type="hidden"
                            name="credit_number_start_month"
                            value={this.state.start_month}
                            className="form-control"
                        />
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <label htmlFor="name" className="col-md-3 col-form-label">
                          Bulan Akhir{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <Col md="5">
                            <CustomSelect
                              name="credit_number_end_month"
                              errorMessage="Pilih Bulan Akhir"
                              options={this.state.monthOptions}
                              placeholder="Pilih Bulan Akhir"
                              defaultValue={this.state.end_month}
                              onChange={(v) => {
                                this.setState({ end_month: v.value });
                              }}
                              isAvForm={false}
                            />
                              <AvField
                                type="hidden"
                                name="credit_number_end_month"
                                value={this.state.end_month}
                                className="form-control"/>
                        </Col>
                      </Row>
                      </>
                    ) }
                    

                    <Row className="mb-3">
                      <label htmlFor="name" className="col-md-3 col-form-label">
                        Angka Kredit{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                      <AvField
                        name="credit_number_value"
                        placeholder="Angka Kredit..."
                        type="text"   // from number → text
                        errorMessage="Masukkan Angka Kredit"
                        className="form-control"
                        validate={{
                          required: { value: true, errorMessage: "Masukkan Angka Kredit" },
                          pattern: {
                            value: /^[0-9.,]+$/,
                            errorMessage: "Hanya angka, titik, atau koma"
                          }
                        }}
                        id="credit_number_value"
                        onChange={this.handleTotalCreditChange}
                      />

                        {/* <AvField
                          name="credit_number_value"
                          placeholder=" Angka Kredit..."
                          type="number"
                          errorMessage="Masukkan Angka Kredit"
                          className="form-control"
                          id="credit_number_value"
                          onChange={this.handleTotalCreditChange}
                          validate={{
                            required: { value: true, errorMessage: "Masukkan Angka Kredit" },
                            pattern: {
                              value: /^[0-9.,]+$/,
                              errorMessage: "Hanya angka, titik, atau koma"
                            }
                          }}
                        /> */}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label htmlFor="name" className="col-md-3 col-form-label">
                        Unggah SKP <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <FileInput
                          name="file_skp"
                          validate={{ required: { value: true } }}
                          col="6"
                          isMultiple={false}
                          maxFiles={1}
                          errorMessage="Harap pilih file SKP"
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label htmlFor="name" className="col-md-3 col-form-label">
                        Unggah PAK 
                        {this.state.creditType == 2 && (
                        <span className="text-danger">*</span>
                        )}
                      </label>
                      <Col md="5">
                        <FileInput
                          name="file_pak"
                          validate={{ required: { value: 
                            this.state.creditType != 1
                           } }}
                          col="6"
                          isMultiple={false}
                          maxFiles={1}
                          errorMessage="Harap pilih file PAK"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="/kepegawaian/pengajuan_angka_kredit.html">
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/kepegawaian/home.html?riwayat_angkakredit" />
        ) : null}
      </Fragment>
    );
  }
}

export default IndexView;
